import PropTypes from "prop-types";

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

export default propTypes;
